import { Injectable, Injector } from '@angular/core';

import { BitfAppSessionService } from '@bitf/services/app-session/bitf-app-session.service';
import { BitfTagManagerService } from '@bitf/services/tag-manager/bitf-tag-manager.service';
import { BitfLogDnaSenderService } from '@bitf/services/logger/bitf-log-dna-sender.service';
import { BitfPwaService } from '@bitf/services/pwa/bitf-pwa.service';
import { ResponsiveService } from '@services';
import { environment } from '@env/environment';
import { BitfDynamicLocaleService } from '@common/libs/bitforce/core/services/locale/bitf-dynamic-locale.service';
import { CONSTANTS } from '@common/constants/common.constants';
import { PublicBundle } from '../models';
import { TranslateService } from '@ngx-translate/core';
import { bitfToTranslate } from '@common/libs/bitforce/utils/bitf-translate.utils';

@Injectable({
  providedIn: 'root',
})
export class AppSessionService extends BitfAppSessionService {
  get cookiePolicyUrl() {
    return `https://www.iubenda.com/privacy-policy/${
      this.bitfDynamicLocaleService?.locale?.code === 'it' ? '21518436' : '59325923'
    }/cookie-policy`;
  }
  get privacyPolicyUrl() {
    return `https://www.iubenda.com/privacy-policy/${
      this.bitfDynamicLocaleService?.locale?.code === 'it' ? '21518436' : '59325923'
    }`;
  }
  constructor(
    private bitfTagManagerService: BitfTagManagerService,
    private bitfLogDnaSenderService: BitfLogDnaSenderService,
    private responsiveService: ResponsiveService,
    protected bitfPwaService: BitfPwaService,
    protected bitfDynamicLocaleService: BitfDynamicLocaleService,
    protected injector: Injector,
    protected translateService: TranslateService
  ) {
    super(injector);
  }

  async init() {
    await super.init();
    // NOTE: At this point translations are already loaded

    this.initBreakpointListener();
    this.responsiveService.init();

    // this.bitfTagManagerService.init();

    this.bitfMetadataService.setDefaultDescription();

    // PWA
    // this.bitfPwaService.initOnlineChecker();
    // this.bitfPwaService.showDefaultOnlineStateChangeToast();
    // if (environment.registerServiceWorker) {
    //   this.bitfPwaService.init();

    //   this.bitfPwaService.initManifest();

    //   this.bitfPwaService.initSwUpdate();
    //   this.bitfPwaService.handleSwUpdate();

    //   this.bitfPwaService.initBeforeInstallPrompt();
    //   this.bitfPwaService.checkForBeforeInstallPromptEvent();
    // }
  }

  initLogSender() {
    this.bitfLogDnaSenderService.init();
  }

  getTranslatedPublicBundleUrl(publicBundle: PublicBundle) {
    return [
      '/',
      this.bitfDynamicLocaleService?.locale?.code,
      CONSTANTS.URL_ROUTES_TRANSLATION.investments[this.bitfDynamicLocaleService?.locale?.code],
      publicBundle.id,
      publicBundle.slug,
    ];
  }

  getTranslatedUrl(routeName: string) {
    return [
      '/',
      this.bitfDynamicLocaleService?.locale?.code,
      CONSTANTS.URL_ROUTES_TRANSLATION[routeName][this.bitfDynamicLocaleService?.locale?.code],
    ];
  }
}
